import { render, staticRenderFns } from "./TerminalPreview.vue?vue&type=template&id=dc9b432e&scoped=true&"
import script from "./TerminalPreview.vue?vue&type=script&lang=ts&"
export * from "./TerminalPreview.vue?vue&type=script&lang=ts&"
import style0 from "./TerminalPreview.vue?vue&type=style&index=0&id=dc9b432e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9b432e",
  null
  
)

export default component.exports